import { z } from 'zod';

/**
 * NBC School Holidays API Response Schemas
 *
 * Schemas for the school-holiday endpoints:
 *   GET /nbc/holidays/{country}                          → states list
 *   GET /nbc/holidays/{country}/{state}/school-holidays  → school holidays
 *
 * @module types/schemas/nbc/holidays
 */

export const NBCStateSchema = z.object({
  name: z.string(),
  slug: z.string(),
});

export type NBCState = z.infer<typeof NBCStateSchema>;

export const NBCStatesResponseSchema = z.object({
  states: z.array(NBCStateSchema),
});

export type NBCStatesResponse = z.infer<typeof NBCStatesResponseSchema>;

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const NBCHolidayPeriodSchema = z.object({
  start: z.string().regex(ISO_DATE_REGEX),
  end: z.string().regex(ISO_DATE_REGEX),
});

export type NBCHolidayPeriod = z.infer<typeof NBCHolidayPeriodSchema>;

export const NBCHolidaySchema = z.object({
  type: z.string(),
  name: z.string(),
  district: z.string(),
  periods: z.array(NBCHolidayPeriodSchema).min(1),
});

export type NBCHoliday = z.infer<typeof NBCHolidaySchema>;

export const NBCHolidaysResponseSchema = z.array(NBCHolidaySchema);

export type NBCHolidaysResponse = z.infer<typeof NBCHolidaysResponseSchema>;
